import { Image } from 'react-bootstrap';
import loading from '../assets/loading.gif';
import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';

const LoadingOverlay = () => {
	const { isAuthenticated } = useAuth0()

	return (
		<>
			<div id="loading-overlay" className="position-fixed top-0 start-0 w-100 h-100">
				<div
					id="loading-overlay-text"
					className="d-flex flex-column justify-content-center align-items-center h-100"
				>
					<h3 className="text-center loading-overlay-title">Welcome to Language IO</h3>
					<p className="text-center loading-overlay-subtitle">Just a moment while we load your languages
						and glossary.</p>
					<Image id="loading-gif" src={loading} alt={'loading'} />
				</div>
			</div>
		</>
	);
}

export default LoadingOverlay;